// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OJxvQ","controls":"styles_controls__1TTdZ","charLimit":"styles_charLimit__Dyy9Q","input":"styles_input__2zj38","send":"styles_send__1jLUh"};